import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/file.dto';

export * from './functions/infer-file-record-category.function';

export * from './enums/file-record-category.enum';
export * from './enums/file-sensitivity.enum';

export * from './validators/schemas/file.schema';

export const fileValidators = { canCreateOrUpdate };
